module.exports = __webpack_public_path__ + "img/react.ab34a2d6.png";